import React, { FC, useState } from 'react';
import {
  AgreementStructure,
  AgreementStudentStructure,
  LearningLanguageNameMap,
  LessonFormatNameMap
} from "../../../shared/types/agreement";
import { TeacherRole } from "../../../shared/types/teacher";
import HLInfoRow, { HLInfoRowSizeType, HLInfoRowStyleType } from '../../../shared/components/info-row/HLInfoRow';
import HLButton, { HLButtonStyleType } from "../../../shared/components/button/HLButton";
import HLLine from "../../../shared/components/line/HLLine";
import UpdateAgreementModal from "../../../modal/agreement/UpdateAgreementModal";
import classes from "./AgreementInfoCard.module.scss";
import { useAppSelector } from "../../../shared/hooks/useAppSelector";

interface AgreementInfoCardProps {
    agreement: AgreementStructure;
    setAgreement: (agreement: AgreementStructure) => void;
}

const AgreementInfoCard: FC<AgreementInfoCardProps> = ({
                                                           agreement,
                                                           setAgreement
                                                       }) => {
    const {currentTeacher} = useAppSelector(state => state.auth);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleEdit = () => {
        setIsEditModalOpen(true);
    };

    const handleStudentClick = (student: AgreementStudentStructure) => {
        window.open(`/agreements/${agreement.id}/students/${student.id}`, '_blank', 'noreferrer');
    }
    
    const copyTelegram = async (telegram: string) => {
        await navigator.clipboard.writeText(telegram);
    };

    function getStudentValue(student: AgreementStudentStructure) {
        const lessonPrice = currentTeacher?.role === TeacherRole.ADMIN ? `(${student.lessonPrice} ₽)` : '';
        return `${student.firstName} ${student.lastName || ''} ${lessonPrice}`;
    }

    return (
        <div className={classes.contentContainer}>
            <h2 className={classes.formTitle}>Информация о договоре</h2>

            <HLInfoRow label="Название:" value={agreement.name}/>
            <HLInfoRow label="Дата договора:" value={agreement.agreementDate}/>
            <HLInfoRow label="Язык обучения:" value={LearningLanguageNameMap[agreement.learningLanguage]}/>
            <HLInfoRow label="Формат занятий:" value={LessonFormatNameMap[agreement.lessonFormat]}/>
            <HLInfoRow label="Статус:" value={agreement.enabled ? 'Активен' : 'Неактивен'}
                       styleType={agreement.enabled ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}/>

            <HLLine/>
            <h3 className={classes.formTitle}>Учитель</h3>
            <HLInfoRow
                value={`${agreement.teacher.firstName} ${agreement.teacher.lastName} (${agreement.teacher.teacherRate} ₽)`}/>

            <HLLine/>
            <h3 className={classes.formTitle}>Ученики</h3>
            {agreement.students && agreement.students
                .map(student => <>
                    {
                        currentTeacher?.role === TeacherRole.ADMIN
                            ? <HLInfoRow
                                value={getStudentValue(student)}
                                onClick={() => handleStudentClick(student)}
                                styleType={HLInfoRowStyleType.CLICKABLE}
                            />
                            : <HLInfoRow
                                value={getStudentValue(student)}
                            />
                    }
                    <HLInfoRow label="Осталось уроков: "
                               value={student.availableLessons}
                               styleType={student.availableLessons > 0 ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}
                               sizeType={HLInfoRowSizeType.SMALL}
                    />
                    {student.telegram && (
                        <HLInfoRow label="Telegram:"
                                   value={student.telegram}
                                   onClick={() => copyTelegram(student.telegram!)}
                                   styleType={HLInfoRowStyleType.CLICKABLE}
                                   sizeType={HLInfoRowSizeType.SMALL}
                        />
                    )}
                </>)}

            {currentTeacher?.role === TeacherRole.ADMIN && (
                <>
                    <HLLine/>
                    <HLButton
                        onClick={handleEdit}
                        styleType={HLButtonStyleType.ORANGE}
                    >
                        Изменить
                    </HLButton>
                </>
            )}

            <UpdateAgreementModal
                open={isEditModalOpen}
                setOpen={setIsEditModalOpen}
                agreement={agreement}
                setAgreement={setAgreement}
            />
        </div>
    );
};

export default AgreementInfoCard;